import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var subheading = designTokenFonts.subheading,
  mini = designTokenFonts.mini;
var colours = tokens.colors;
export var agent = {
  name: "xi606m",
  styles: "text-align:center;"
};
export var name = /*#__PURE__*/css(subheading, ";");
export var agentLink = /*#__PURE__*/css("display:block;color:", colours.neutral.heavy.default, ";text-decoration:none;");
export var agency = /*#__PURE__*/css(mini, ";margin-bottom:10px;");
var _ref = {
  name: "1wsuzl7",
  styles: "width:64px;height:64px;"
};
var _ref2 = {
  name: "1lhmg90",
  styles: "width:160px;height:160px;"
};
export var avatar = _ref3 => {
  var largePhoto = _ref3.largePhoto;
  return /*#__PURE__*/css("display:inline-block;", !largePhoto && _ref, " ", largePhoto && _ref2);
};
export var awardPill = {
  name: "lw7y9j",
  styles: "display:flex;align-items:center;justify-content:center;margin-bottom:20px;"
};